<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">

      <!-- Page Header -->
      <div class="page-header">
        <div class="container">
          <div class="d-flex align-items-center justify-content-between text-white" style="padding: 32px 0;">
            <div class="d-flex align-items-center" style="gap: 16px;">
              <div class="header-icon-wrap">
                <i class="fe fe-users" style="font-size: 22px;"></i>
              </div>
              <div>
                <h4 class="mb-0 font-weight-bold">Enrollees</h4>
                <small style="opacity: .8;">Browse and filter enrollee records</small>
              </div>
            </div>
            <button type="button" class="btn btn-outline-light btn-sm"
              @click="getUserData(currentPage ? currentPage : 1)">
              <i class="fe fe-refresh-cw mr-1"></i> Refresh
            </button>
          </div>
        </div>
      </div>

      <div class="container mt-n3 pb-5">

        <SearchUser />

        <!-- Filter Card -->
        <div class="card table-card shadow mb-4">
          <div class="form-card-header">
            <div class="section-number"><i class="fe fe-sliders" style="font-size:13px;"></i></div>
            <div>
              <p class="mb-0 text-white font-weight-bold" style="font-size:.95rem;">Filter Parameters</p>
              <small style="color:rgba(255,255,255,.7);">Narrow results by sector, location, and more</small>
            </div>
          </div>
          <div class="card-body">
            <div class="row">

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-credit-card mr-1"></i>Select Sector Plan</label>
                <select class="form-control" v-model="sector">
                  <option :value="sector" v-for="sector in sectors" :key="sector">
                    {{ sector }}
                  </option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-map-pin mr-1"></i>Select LGA</label>
                <select class="form-control" v-model="localgovt" @change="fetchWards($event)">
                  <option v-for="lga in lga_states" v-bind:key="lga" :value="lga.id">{{ lga.local_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-navigation mr-1"></i>Ward</label>
                <select class="form-control" v-model="ward">
                  <option v-for="ward in wards" v-bind:key="ward.id" :value="ward.id">{{ ward.ward_name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-user-plus mr-1"></i>Select Gender</label>
                <select class="form-control" v-model="gender">
                  <option value="Male">Male</option>
                  <option value="Female">Female</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-activity mr-1"></i>Select Facility</label>
                <v-select v-model="provider_id" :options="providers" label="agency_name"
                  :reduce="provider => provider.id" placeholder="Select facility…"></v-select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-briefcase mr-1"></i>Select MDA</label>
                <select class="form-control" v-model="place_of_work">
                  <option :value="mda.name" v-for="mda in mdas" v-bind:key="mda.id">{{ mda.name }}</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Special Needs</label>
                <select class="form-control" v-model="category_of_vulnerable_group">
                  <option value="All">All</option>
                  <option value="Pregnant Women">Pregnant Women</option>
                  <option value="Children under 5">Children under 5</option>
                  <option value="Aged">Aged</option>
                  <option value="People with Special Needs">People with Special Needs</option>
                  <option value="Poorest of the Poor">Poorest of the Poor</option>
                  <option value="State Pensioners">State Pensioners</option>
                  <option value="LGA Pensioners">LGA Pensioners</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-user-plus mr-1"></i>Select Employee</label>
                <v-select v-model="enrolled_by" :options="employees.data"
                  :get-option-label="emoployee => `${emoployee.firstname} ${emoployee.lastname}`"
                  :reduce="emoployee => emoployee.id" placeholder="Select employee…"></v-select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Select Status</label>
                <select class="form-control" v-model="enabled_user">
                  <option value="1">Active</option>
                  <option :value="false">Inactive</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>Start Date</label>
                <input type="date" class="form-control" v-model="from" @change="pushDate" />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-calendar mr-1"></i>End Date</label>
                <input type="date" class="form-control" v-model="to" @change="pushDate" />
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1">Select Row</label>
                <select class="form-control" v-model="perPage">
                  <option value="15">15</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                  <option value="500">500</option>
                  <option value="1000">1000</option>
                  <option value="5000">5000</option>
                </select>
              </div>

              <div class="form-group col-md-3">
                <label class="info-label d-block mb-1"><i class="fe fe-layers mr-1"></i>Group By</label>
                <select class="form-control" v-model="group_by">
                  <option value="">None</option>
                  <option value="place_of_work">Place of Work</option>
                  <option value="provider">Provider</option>
                  <option value="hmo">HMO</option>
                </select>
              </div>

              <div class="col-md-12 pt-3 border-top">
                <div class="d-flex flex-wrap" style="gap:10px;">
                  <button @click="getUserData(currentPage ? currentPage : 1)" class="btn btn-submit px-4">
                    <i class="fe fe-filter mr-1"></i> Filter
                  </button>
                  <button class="btn btn-outline-dark" @click="getUserData(0, 'csv')">
                    <i class="fe fe-file-text mr-1"></i> Export Excel
                  </button>
                  <button @click="clearFilter" class="btn btn-outline-secondary ml-auto">
                    <i class="fe fe-x-circle mr-1"></i> Clear
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>

        <!-- Results Table -->
        <div class="card table-card shadow mb-4">
          <div class="card-body pb-0">
            <div class="mb-3 d-flex align-items-start justify-content-between">
              <div>
                <p class="h5 mb-1">
                  Total Records:
                  <span class="text-primary">{{ (clients.meta.total_principal + clients.meta.total_dep) | numeral(0, 0)
                    }}</span>
                </p>
                <div class="d-flex" style="gap:16px; font-size:.85rem; color:#64748b;">
                  <span>Principals: <strong>{{ clients.meta.total_principal }}</strong></span>
                  <span>Dependents: <strong>{{ clients.meta.total_dep }}</strong></span>
                </div>
              </div>
              <div class="view-toggle">
                <button :class="['view-toggle-btn', viewMode === 'list' ? 'active' : '']" @click="viewMode = 'list'"
                  title="List view"><i class="fe fe-list"></i></button>
                <button :class="['view-toggle-btn', viewMode === 'grid' ? 'active' : '']" @click="viewMode = 'grid'"
                  title="Grid view"><i class="fe fe-grid"></i></button>
              </div>
            </div>
          </div>
          <div class="table-responsive" v-if="viewMode === 'list'">
            <table class="table align-td-middle mb-0">
              <thead class="table-head">
                <tr>
                  <th class="table-th">Avatar</th>
                  <th class="table-th">Name</th>
                  <th class="table-th">Phone Number</th>
                  <th class="table-th">Sector</th>
                  <th class="table-th">KGSHIA Number</th>
                  <th class="table-th text-center">Dependents</th>
                  <th class="table-th">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr class="table-row" v-for="client in clients.data" v-bind:key="client.id">
                  <td>
                    <div class="avatar avatar-sm" v-if="client.user_image != null">
                      <img :src="`https://claimify-api.hayokmedicare.ng/image/${client.user_image}`"
                        class="avatar-img avatar-sm rounded-circle"
                        onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'" />
                    </div>
                    <div class="avatar avatar-sm" v-else>
                      <div class="avatar-title rounded-circle bg-soft-primary text-primary" style="font-size:.75rem;">
                        {{ client.full_name ? client.full_name.charAt(0) : '?' }}
                      </div>
                    </div>
                  </td>
                  <td class="font-weight-bold">{{ client.full_name }}</td>
                  <td>{{ client.phone_number }}</td>
                  <td>
                    <span class="badge badge-soft-info" style="font-size:.75rem;">{{ client.sector }}</span>
                  </td>
                  <td><span class="code-chip">{{ client.id_card_number }}</span></td>
                  <td class="text-center">
                    <span v-if="client.dependants_count !== undefined" class="badge badge-soft-secondary"
                      style="font-size:.75rem;">{{ client.dependants_count }}</span>
                    <span v-else class="text-muted">—</span>
                  </td>
                  <td>
                    <div class="d-flex" style="gap:4px;">
                      <button class="btn btn-sm btn-outline-danger" @click="disableUser(client.id)"
                        v-if="client.enabled_user == 1">Disable</button>
                      <button class="btn btn-sm btn-outline-success" @click="enableUser(client.id)"
                        v-else-if="client.enabled_user == 0">Enable</button>
                      <router-link :to="{ path: '/client/' + client.id }" v-if="client.account_type == 'Principal'">
                        <button type="button" class="btn btn-sm btn-outline-primary"><i class="fe fe-eye"></i></button>
                      </router-link>
                      <router-link :to="{ path: '/dependent/' + client.id }" v-else>
                        <button type="button" class="btn btn-sm btn-outline-primary"><i class="fe fe-eye"></i></button>
                      </router-link>
                      <button class="btn btn-sm btn-outline-secondary" @click="getDependents(client)"
                        data-toggle="collapse" :data-target="'#collapseExample' + client.id" aria-expanded="false">
                        <i class="fe fe-users"></i>
                      </button>
                    </div>
                    <div class="collapse mt-2" :id="'collapseExample' + client.id">
                      <table class="table table-sm mb-0">
                        <tr>
                          <th style="font-size:.72rem;">Name</th>
                          <th style="font-size:.72rem;">Relationship</th>
                          <th style="font-size:.72rem;">Gender</th>
                        </tr>
                        <tr v-for="dep in dependents" v-bind:key="dep.id">
                          <td>{{ dep.firstname }} {{ dep.lastname }}</td>
                          <td>{{ dep.relationShipType }}</td>
                          <td>{{ dep.gender }}</td>
                        </tr>
                      </table>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="clients-grid" v-if="viewMode === 'grid'">
            <div v-if="!clients.data || !clients.data.length" style="grid-column:1/-1"
              class="text-center py-5 text-muted">
              <i class="fe fe-users" style="font-size:2rem;opacity:0.3"></i>
              <p class="mt-2 mb-0">No enrollees found</p>
            </div>
            <div v-for="client in clients.data" :key="client.id" class="client-grid-card">
              <div class="d-flex align-items-center mb-3" style="gap:12px;">
                <div v-if="client.user_image" class="avatar avatar-sm">
                  <img :src="`https://claimify-api.hayokmedicare.ng/image/${client.user_image}`" class="rounded-circle"
                    style="width:44px;height:44px;object-fit:cover;"
                    onerror="this.onerror=null; this.src='/assets/img/kgshia_logo.png'" />
                </div>
                <div v-else
                  class="rounded-circle d-flex align-items-center justify-content-center bg-soft-primary text-primary"
                  style="width:44px;height:44px;min-width:44px;font-size:.85rem;font-weight:700;">
                  {{ client.full_name ? client.full_name.charAt(0) : '?' }}
                </div>
                <div>
                  <div class="font-weight-bold" style="font-size:.9rem;">{{ client.full_name }}</div>
                  <span class="code-chip">{{ client.id_card_number }}</span>
                  <div v-if="client.dependants_count !== undefined" style="font-size:.78rem;color:#64748b;">
                    <i class="fe fe-users mr-1"></i>{{ client.dependants_count }} {{ client.dependants_count == 1 ? 'dependent' : 'dependents' }}
                  </div>
                </div>
              </div>
              <div class="mb-3" style="font-size:.83rem;color:#64748b;">
                <div><i class="fe fe-phone mr-1"></i>{{ client.phone_number || '—' }}</div>
                <div class="mt-1"><span class="badge badge-soft-info" style="font-size:.75rem;">{{ client.sector
                    }}</span></div>
              </div>
              <div class="d-flex grid-card-footer" style="gap:6px;">
                <button class="btn btn-sm btn-outline-danger" @click="disableUser(client.id)"
                  v-if="client.enabled_user == 1">Disable</button>
                <button class="btn btn-sm btn-outline-success" @click="enableUser(client.id)"
                  v-else-if="client.enabled_user == 0">Enable</button>
                <router-link :to="{ path: '/client/' + client.id }" v-if="client.account_type == 'Principal'"
                  class="ml-auto">
                  <button type="button" class="btn btn-sm btn-outline-primary"><i
                      class="fe fe-eye mr-1"></i>View</button>
                </router-link>
                <router-link :to="{ path: '/dependent/' + client.id }" v-else class="ml-auto">
                  <button type="button" class="btn btn-sm btn-outline-primary"><i
                      class="fe fe-eye mr-1"></i>View</button>
                </router-link>
              </div>
            </div>
          </div>
          <div class="card-body pt-2">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"
              @input="getUserData(currentPage ? currentPage : 1)"></b-pagination>
          </div>
        </div>

      </div>

      <div class="vld-parent">
        <loading :active.sync="isLoading" loader="dots" :can-cancel="true" :is-full-page="fullPage"></loading>
      </div>
    </main>
  </section>
</template>

<script>
  import Navbar from "@/views/Navbar.vue";
  import SearchUser from "@/views/shis/components/SearchUser.vue";
  // Import component
  import Loading from "vue-loading-overlay";
  // Import stylesheet
  import "vue-loading-overlay/dist/vue-loading.css";
  // Init plugin
  import { downloadGroupedXlsx } from "@/service/xlsx_export";

  export default {
    components: {
      Navbar,
      Loading,
      SearchUser,
    },
    data() {
      return {
        isLoading: false,
        fullPage: true,
        user: null,
        sectors: [
          "Basic Healthcare Provision Fund",
          "State Equity Program",
          "Voluntary Contributor",
          "State Civil Servant",
          "State Public Servant",
          "LGA Civil Servant",
          "Organized Private Sector",
          "T-SHIP",
          "State Pensioners Plan",
          "LGA Pensioners Plan",


        ],
        clients: {
          meta: { total_principal: 0, total_dep: 0 },
          data: []
        },
        providers: "",
        mdas: "",
        wards: "",
        state: "",
        lga_states: "",
        category_of_vulnerable_group: "",
        employees: "",
        provider_id: "",
        sector: "",
        place_of_work: "",
        localgovt: "",
        dependents: "",
        enrolled_by: "",
        gender: "",
        enabled_user: 1,
        group_by: "",
        ward: "",
        date: "",
        from: "",
        to: "",
        current_page: 1,
        currentPage: 1,
        rows: "1",
        perPage: 15,
        viewMode: 'list',
        json_fields: {
          // ID: "id",
          "User Type": "account_type",
          // 'First Name': 'firstname',
          "Full Name": "full_name",
          "AGENCY ID": "id_card_number",
          "AGENCY ID (Dependent) ": "user.id_card_number",
          "User Status": "status",
          "Picture Available": "picture_available",
          "User Image": {
            field: "user_image",
            callback: (value) => {
              return `https://claimify-api.hayokmedicare.ng/image/${value}`;
            },
          },

          phone_number: "phone_number",
          "Sector Category": "sector",
          // "Sector Category(Dependent) ": "user.sector",
          "Computer Number": "salary_number",
          "Computer Number(Dependent)": "user.salary_number",
          "LGA (Dependent)": "user.localgovt",
          "Vulnerable Group": "category_of_vulnerable_group",
          "Date of Birth": "dob",
          "Local Govt": "localgovt.local_name",
          Ward: "ward.ward_name",
          "Card Expiry Date": "expiry_date",
          "Sector(Principal) ": "sectorType",
          // "Sector(Dependent) ": "user.sectorType",
          gender: "gender",
          "Date Enrolled": "created_at",
          "Means of ID": "nimc_number",
          "Plan Type": "plan_type",
          // "Plan Type (Dependent)": "user.plan_type",
          "Enrollee MDA": "place_of_work",
          "Enrollee Address": "address1",
          "Health Facility": "userprovider.agency_name",
          "Health Facility (DEP)": "userprovider.agency_name",
        },
        json_data: [],
        json_meta: [
          [
            {
              key: "charset",
              value: "utf-8",
            },
          ],
        ],
      };
    },
    beforeMount() {
      this.user = JSON.parse(localStorage.getItem("user"));
    },
    mounted() {
      this.viewMode = window.innerWidth < 768 ? 'grid' : 'list';
      this.getUserData();
    },
    methods: {
      getUserData(currentPage, format) {
        this.isLoading = true;

        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/getUsersfilterparams`, {
            params: {
              format: format ? format : "",
              page: currentPage,
              agency_id: 90,
              perPage: this.perPage ? this.perPage : null,
              provider_id: this.provider_id ? this.provider_id : "",
              sector: this.sector ? this.sector : "",
              gender: this.gender ? this.gender : "",
              group_by: this.group_by ? this.group_by : "",
              enabled_user: this.enabled_user,
              place_of_work: this.place_of_work ? this.place_of_work : "",
              localgovt: this.localgovt ? this.localgovt : "",
              enrolled_by: this.enrolled_by ? this.enrolled_by : "",
              date: this.date ? this.date : "",
              from: this.from ? this.from : "",
              to: this.to ? this.to : "",
              ward: this.ward ? this.ward : "",
              category_of_vulnerable_group: this.category_of_vulnerable_group
                ? this.category_of_vulnerable_group
                : "",
            },
          })
          .then((response) => {
            if (format === "csv") {
              const fileName = `enrollees_${new Date().toISOString().slice(0, 10)}.xlsx`;
              downloadGroupedXlsx(response.data, this.group_by, fileName);
              this.$toasted.success("Excel file downloaded successfully", {
                position: "top-center",
                duration: 3000,
              });
              this.isLoading = false;
              return;
            }

            this.clients = response.data;
            this.rows = response.data.meta.total_principal;
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;

            console.error(error);
          });
      },
      clearFilter() {
        this.ward = "";
        this.date = "";
        this.from = "";
        this.to = "";
        this.sector = "";
        this.localgovt = "";
        this.provider_id = "";
        this.place_of_work = "";
        this.group_by = "";
        this.enrolled_by = "";
      },
      getLGA() {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/lga/2669`)
          .then((response) => {
            this.lga_states = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      pushDate() {
        this.date = "date";
      },
      getEmployees() {
        this.axios
          .get(`/api/v1/auth/getEmployee/90`)
          .then((response) => {
            this.employees = response.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      fetchWards() {
        this.axios
          .get(`/api/v1/auth/getwards/${this.localgovt}`)
          .then((response) => {
            this.wards = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      getDependents(client) {
        this.user = JSON.parse(localStorage.getItem("user"));
        this.axios
          .get(`/api/v1/auth/allDependantUser/${client.id}`)
          .then((response) => {
            this.dependents = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      disableUser(user_id) {
        //   alert(user_id);
        this.axios
          .post(`/api/v1/auth/disableUser/` + user_id)
          .then(() => {
            alert("User disabled");
          })
          .catch((error) => {
            console.error(error);
          });
      },
      enableUser(user_id) {
        //   alert(user_id);
        this.axios
          .post(`/api/v1/auth/enableUser/` + user_id)
          .then(() => {
            alert("User enabled");
            this.getUsers();
          })
          .catch((error) => {
            console.error(error);
          });
      },

      getProviders() {
        this.axios
          .get(`/api/v1/auth/providerAgency/90`)
          .then((response) => {
            this.providers = response.data.data;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      },
      changeNumberID(client) {
        this.isLoading = true;
        this.axios
          .patch(`/api/v1/auth/id-card-number/change/${client.id}`)
          .then((response) => {
            console.log(response);
            this.$toasted.success("Changed Successfully", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.$toasted.error("Not Found!", {
              position: "top-center",
              duration: 3000,
            });
            this.isLoading = false;
          });
      },

      getMDAs() {
        this.axios
          .get(`/api/v1/auth/ministries/90`)
          .then((response) => {
            this.mdas = response.data.data;
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });
      },
    },
    created() {
      this.getLGA();
      this.getProviders();
      this.getMDAs();
      this.getEmployees();
    },
  };
</script>

<style scoped>
  /* ── Design-system classes (kgshia has no global design-system.css yet,
     so these are inlined locally to match claimify's shared admin theme) ── */
  .page-header {
    background: linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%);
    padding-bottom: 60px;
  }

  .header-icon-wrap {
    width: 52px;
    height: 52px;
    background: rgba(255, 255, 255, 0.18);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .container.mt-n3 {
    margin-top: -32px !important;
  }

  .table-card {
    border-radius: 14px !important;
    border: none !important;
    overflow: hidden;
  }

  .form-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 16px 24px;
    background: linear-gradient(135deg, #1e3a5f, #2563eb);
  }

  .section-number {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.25);
    color: #fff;
    font-size: 13px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .info-label {
    font-size: 0.7rem;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: #94a3b8;
    margin-bottom: 1px;
    font-weight: 600;
  }

  .table-head {
    background: #f8fafc;
  }

  .table-th {
    font-size: 0.75rem !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    color: #64748b !important;
    font-weight: 600 !important;
    border-bottom: 2px solid #e2e8f0 !important;
    padding: 12px 16px !important;
    white-space: nowrap;
  }

  .table-row {
    border-color: #f1f5f9 !important;
    transition: background 0.15s;
  }

  .table-row:hover {
    background: #f8fafc !important;
  }

  .btn-submit {
    background: linear-gradient(135deg, #2563eb, #7c3aed) !important;
    color: #fff !important;
    border: none !important;
    border-radius: 8px !important;
    font-weight: 600 !important;
    transition: opacity 0.15s;
  }

  .btn-submit:hover,
  .btn-submit:focus {
    opacity: 0.9;
    color: #fff !important;
  }

  /* ── View toggle ── */
  .view-toggle {
    display: flex;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    overflow: hidden;
  }

  .view-toggle-btn {
    background: none;
    border: none;
    padding: 6px 10px;
    color: #94a3b8;
    cursor: pointer;
    font-size: .85rem;
    line-height: 1;
  }

  .view-toggle-btn.active {
    background: #1e3a5f;
    color: #fff;
  }

  .view-toggle-btn:hover:not(.active) {
    background: #f1f5f9;
    color: #475569;
  }

  /* ── Grid view ── */
  .clients-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 16px;
    padding: 20px 24px;
  }

  .client-grid-card {
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    padding: 16px;
    background: #fff;
    display: flex;
    flex-direction: column;
    transition: border-color .15s, box-shadow .15s;
  }

  .client-grid-card:hover {
    border-color: #93c5fd;
    box-shadow: 0 2px 10px rgba(37, 99, 235, .1);
  }

  .grid-card-footer {
    border-top: 1px solid #f1f5f9;
    padding-top: 10px;
    margin-top: auto;
  }

  .code-chip {
    background: #f1f5f9;
    color: #1e3a5f;
    padding: 2px 8px;
    border-radius: 6px;
    font-size: .78rem;
    font-weight: 600;
  }
</style>